import createVueApp from '@phoenix/createVueApp';
import PersonalAssistantModal from '@maison/components/product/PersonalAssistantModal.vue';

const app = createVueApp();
app.component('PersonalAssistantModal', PersonalAssistantModal);
app.mount('#phoenix-personal-assistant-modal');
